import type { HybridWeblogInitParams } from '@/types/configuration';

export default (options?: HybridWeblogInitParams[0]): HybridWeblogInitParams[0] => {
    const logConfig: HybridWeblogInitParams[0] = {
        env: 'production',
        proto: 'v3',
        timeout: 30000,
        wait: 1000,
        maxBatchLength: 50,
        sampleRate: 1,
        // 尝试从全局中获取 yoda
        yoda: typeof window !== 'undefined' && (window as any).yoda,
        forbidV2HttpUrlPage: true,
        ...(options || {})
    };
    return logConfig;
};

export type LogConfig =  HybridWeblogInitParams[0];

export type BridgeLogConfig = {
    /**
     * 是否禁止 PV，用于将 H5 作为端内元素上报，不会上报 PV 事件
     */
    disablePV?: boolean;

    /**
     * 自定义事件所属的业务线，如 LIVE、ESHOP 等
     */
    biz?: string;
    /**
     * 是否在 bridge 模式下同时开启 HTTP 上报
     */
    openHttpSender?: boolean;
}